module.exports = __webpack_public_path__ + "img/loading.5c81aa02.svg";